import { categories } from './categories';
import countries from '../modules/countries.json';
import videos from '../modules/videos';
import facebookPixel from '../scripts/facebook-pixel';
import hotjar from '../scripts/hotjar';
import FloatVideo from '../components/FloatVideo.vue';

const videoSources = videos.map(key => key.src);

const isExtensionInstalled = () => !!document.getElementById('kaoshiStickyNote');

export default {
    data() {
        return {
            FloatVideo: Vue.extend(FloatVideo),
            categories,
            countries,
        };
    },
    methods: {
        formatAmount: (amount) => Number(amount).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }),
        isExtensionInstalled,
        addToCart() {
            const { quantity } = this;
            const isInCart = this.$store.state.shoppingList.filter(key => key.id === this.item.id && key.brand === this.item.brand);
            if(isInCart.length) return this.$swal({
                type: 'warning',
                title: 'Item is already in the cart',
            });

            this.$store.commit('addToCart', { ...this.item, quantity })
            this.$swal({
                type: 'success',
                text: 'Item has been added to the cart',
            });
        },
        addAutoloan() {
            const { quantity } = this;
            const isInCart = this.$store.state.autoloans.filter(key => key.id === this.item.id && key.brand === this.item.brand);
            if(isInCart.length) return this.$swal({
                type: 'warning',
                title: 'This car has already been added!',
            });

            this.$store.commit('addToAutoLoan', { ...this.item, quantity })
            this.$swal({
                type: 'success',
                text: 'This car has been added',
            });
        },
        addToWaitlist(payload) {
            if (!payload.email) {
                return Promise.reject(new Error('Email required'));
            }

            return Vue.backendApi().user().addToWaitlist(payload)
                .then(() => {
                    this.$swal({
                        type: 'success',
                        title: 'Success',
                    });
                })
                .catch((err) => {
                    this.$swal({
                        type: 'error',
                        title: 'Error adding to waitlist',
                        text: err,
                    });
                });
        },
        async copyToClipboard(text, successMessage = '') {
            try {
                await navigator.clipboard.writeText(text);
                this.$swal({
                    type: 'success',
                    title: successMessage || 'Copied to clipboard!',
                });
            } catch (err) {
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||  navigator.userAgent.match(/ipad|iphone/i);
                if(isSafari) {
                    this.copyOnSafari(text, successMessage);
                    return;
                }

                this.$swal({
                    type: 'error',
                    title: 'Unsuccessful',
                });
            }
        },
        copyOnSafari(text, successMessage) {
            let textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.display = 'none';

            document.body.appendChild(textArea);
            textArea.select();

            try {
                const successful = document.execCommand('copy');
                if(successful) {
                    this.$swal({
                        type: 'success',
                        title: successMessage || 'Copied to clipboard!',
                    });
                }

            } catch (e) {
                this.$swal({
                    type: 'error',
                    title: 'Unsuccessful',
                });
            }

            document.body.removeChild(textArea);
        },
        showTutorialVideo(type, redirectToSettings = true) {
            const hash = type === 'payment' ? '#payment-methods' : '#delivery-method';
            const { country_abbreviation, currencies } = this.$store.state.user;
            const { currency_code } = currencies[0] || {};

            let videoSrc = '';

            if(type === 'payment') {
                if(currency_code === 'EUR') {
                    videoSrc = videoSources[13];
                } else {
                    switch (country_abbreviation) {
                        case 'US':
                            videoSrc = videoSources[2];
                            break;
                        case 'CA':
                            videoSrc = videoSources[1];
                            break;
                        case 'NG':
                            videoSrc = videoSources[3];
                            break;
                        default:
                            videoSrc = null;
                    }
                }
            } else {
                if(currency_code === 'EUR') {
                    videoSrc = videoSources[12];
                } else {
                    if(country_abbreviation === 'NG') {
                        videoSrc = videoSources[4];
                    }
                }
            }

            if (redirectToSettings) {
                if (!videoSrc) {
                    this.goToSettings(hash);
                    return;
                }

                this.$swal({
                    type: 'info',
                    html: `
                        <h3 style="text-align: center; margin-bottom: 10px;">Do you want to watch a step-by-step guide on how to add a ${type} method?</h3>
                        <p>The video will be displayed in a picture-in-picture frame</p>
                    `,
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                }).then((result) => {
                    if (result.value) {
                        if (!videoSrc) {
                            this.$swal({
                                type: 'info',
                                title: 'Oops!',
                                text: 'There is no instructional video for this task at this time'
                            });
                        } else {
                            this.openPictureInPicture(`${videoSrc}`);
                        }
                    }

                    this.goToSettings(hash);
                });
            } else {
                this.$router.push({
                    name: 'offers-list',
                });
            }
        },
        goToSettings(hash) {
            if (this.$route.name !== 'user-settings') {
                const { currentRoute } = this.$router;

                // Do not redirect back to send-or-receive-money page again
                const redirectTo = currentRoute.name === 'send-or-receive-money'
                    ? null
                    : currentRoute;

                this.$router.push({
                    name: 'user-settings',
                    params: {
                        redirectTo,
                    },
                    hash,
                });
            }
        },
        openPictureInPicture(src) {
            return new this.FloatVideo({
                propsData: {
                    src,
                },
            }).$mount('#flow-video-container div');
        },
        popupCenter(url, title = '', xAspectRatio = 0.85, yAspectRatio = 0.85, onError) {
            // Fixes dual-screen position                             Most browsers       Firefox
            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

            const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

            const w = width * xAspectRatio;
            const h = height * yAspectRatio;

            const left = (width - w) / 2 + dualScreenLeft;
            const top = (height - h) / 2 + dualScreenTop;

            const metadata = `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`;
            const newWindow = window.open(url, title, metadata);

            if (newWindow && newWindow.focus) {
                newWindow.focus();
            } else {
                if (onError) {
                    onError();
                } else {
                    this.$swal({
                        type: 'error',
                        title: 'Your browser is blocking a pop-up window',
                        text: `Turn off the pop-up window blocker and try again.`,
                    });
                }
            }
        },
        getBrandIconPath: (name) => {
            let logoName = name.toLowerCase().replace(/\s+/g, '-');
            return `/images/brand-icons/${logoName}.png`;
        },
        addScript(url) {
            let scriptTag = document.createElement('script');
            scriptTag.async = true;
            scriptTag.setAttribute('src', url);
            document.head.appendChild(scriptTag);
        },
        addTrackingScripts() {
            const vm = this;
            [hotjar, facebookPixel].forEach((url) => vm.addScript(url));

            function addNoScript() {
                let noScriptTag = document.createElement('no-script');
                const img = document.createElement('img');
                img.height = '1';
                img.width = '1';
                img.src = 'https://www.facebook.com/tr?id=322612959605130&ev=PageView&noscript=1';
                noScriptTag.innerHTML = img;
                document.head.appendChild(noScriptTag);
            }

            addNoScript();
        },
        waitForUnifiedPay () {
            let attempt = 0;

            return new Promise((resolve, reject) => {
                const interval = setInterval(() => {
                    if (window.UnifiedPay) {
                        clearInterval(interval)
                        resolve()
                    }

                    if (attempt > 100) {
                        reject(new Error('UnifiedPay not found'))
                    }

                    attempt += 1
                }, 100)
            })
        },
    },
}
